import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { MessageCircle } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import MessagingDialog from "@/components/MessagingDialog";

export default function TutorMessages() {
  const { getAuthHeader } = useAuth();
  const [open, setOpen] = useState(true);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-slate-900" data-testid="tutor-messages-title">
          Student Messages
        </h1>
        <p className="text-sm text-slate-500 mt-1">
          Message <strong>only the students booked with you today</strong>.
          The list resets every day at midnight (Istanbul time). All conversations
          are monitored for safety — sharing phone numbers, emails, or external
          platforms is automatically blocked.
        </p>
      </div>

      <Card>
        <CardContent className="p-8 flex flex-col items-center text-center gap-4">
          <div className="bg-blue-100 p-4 rounded-full">
            <MessageCircle className="w-8 h-8 text-blue-700" />
          </div>
          <p className="text-sm text-slate-600 max-w-md">
            Click the button below to open your conversations with students.
          </p>
          <Button
            onClick={() => setOpen(true)}
            className="bg-gradient-to-r from-blue-700 to-blue-900 text-white"
            data-testid="open-tutor-messages-btn"
          >
            <MessageCircle className="w-4 h-4 mr-2" /> Open Messages
          </Button>
        </CardContent>
      </Card>

      <MessagingDialog
        open={open}
        onOpenChange={setOpen}
        role="tutor"
        getAuthHeader={getAuthHeader}
      />
    </div>
  );
}
